import React from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * CustomTimeInput - GPS-style time input with clock icon
 * Styled consistently with other custom form components
 * 
 * @param {Object} props
 * @param {string} props.value - Current time value (HH:MM format)
 * @param {Function} props.onChange - Callback when value changes: (value) => void
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Disable the input
 * @param {boolean} props.required - Mark as required field
 */
const CustomTimeInput = ({ 
  value, 
  onChange, 
  placeholder,
  className = '',
  disabled = false,
  required = false
}) => {
  const { t } = useTranslation();
  const resolvedPlaceholder = placeholder ?? t('common.time_placeholder');

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <input 
        type="time" 
        required={required}
        value={value} 
        onChange={handleChange}
        disabled={disabled}
        placeholder={resolvedPlaceholder}
        className={`
          w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 pr-10 text-white 
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
          placeholder-white/30
          [color-scheme:dark]
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      />
      
      {/* Clock Icon */}
      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <Clock size={16} className="text-blue-400/60" />
      </div>
    </div>
  );
};

export default CustomTimeInput;
